export default "__VITE_ASSET__DCIC0af3__"